import { apiFetch } from '../../services/http';
import { getAuthHeaders } from '../../services/authHeaders';
import { NOTIFICATIONS_ENABLED } from '../../services/config';

export type NotificationItem = {
  id: string;
  type: string;
  title: string;
  message?: string;
  content?: string;
  is_read: boolean;
  isRead?: boolean;
  action_url?: string | null;
  actionUrl?: string | null;
  created_at: string | number;
  createdAt?: string | number;
  user_id?: string;
  tenant_id?: string;
};

export const notificationsApi = {
  list: async (token: string, filter?: 'all' | 'unread') => {
    if (!NOTIFICATIONS_ENABLED) {
      return { items: [], data: [], unread_count: 0 };
    }

    try {
      const query = filter ? `?filter=${filter}` : '';
      const res = await apiFetch<{ items?: NotificationItem[]; data?: NotificationItem[]; unread_count?: number }>(`/v1/app/notifications${query}`, {
        headers: getAuthHeaders(token),
      });

      const rawItems = res?.items || res?.data || [];
      const items: NotificationItem[] = rawItems.map((n: any) => {
        const isRead = n.is_read !== undefined ? Boolean(n.is_read) : Boolean(n.isRead);
        const text = n.content || n.message || '';
        const created = n.created_at || n.createdAt;
        const actionUrl = n.action_url || n.actionUrl || null;

        return {
          id: n.id,
          type: n.type || 'info',
          title: n.title || 'Notificação',
          message: text,
          content: text,
          is_read: isRead,
          isRead: isRead,
          action_url: actionUrl,
          actionUrl: actionUrl,
          created_at: created,
          createdAt: created,
          user_id: n.user_id || n.userId,
          tenant_id: n.tenant_id || n.tenantId,
        };
      });

      const unreadCount = res?.unread_count !== undefined 
        ? res.unread_count 
        : items.filter(i => !i.is_read).length;

      return { items, data: items, unread_count: unreadCount };
    } catch (error) {
      if (error instanceof Error && error.message.startsWith('404:')) {
        return { items: [], data: [], unread_count: 0 };
      }
      throw error;
    }
  },

  markAsRead: (token: string, id: string) =>
    NOTIFICATIONS_ENABLED
      ? apiFetch(`/v1/app/notifications/${id}/read`, {
          method: 'POST',
          headers: getAuthHeaders(token),
        })
      : Promise.resolve({ ok: true }),

  markAllRead: (token: string) =>
    NOTIFICATIONS_ENABLED
      ? apiFetch('/v1/app/notifications/read-all', {
          method: 'POST',
          headers: getAuthHeaders(token),
        })
      : Promise.resolve({ ok: true }),
};
